import * as React from "react"

import { createNavigator, MoveHandle } from "Catalog/Edit/shared/components/Navigator"
import { ItemRenderFunction, NavigatorProps } from "Catalog/Edit/shared/components/Navigator/types"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useEditor from "shared/hooks/useEditor"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { DealId } from "shared/hubrise/ids"
import { IDeal } from "shared/hubrise/models"

import { StyledDeal, Name } from "./Styles"

interface DealProps {
  items: Array<IDeal>
  selectedId?: DealId
}

const DealNavigator = createNavigator<IDeal>()

const Navigator = ({ items, selectedId }: DealProps): JSX.Element => {
  const { editor } = useEditor()
  const { catalogNavigation } = useCatalogNavigation()
  const navigate = useNavigateNoUpdate()

  const selectItem = React.useCallback(
    (deal: IDeal): void => navigate(catalogNavigation.editPath("deal", deal.id)),
    [catalogNavigation, navigate],
  )

  const moveItem: NavigatorProps<IDeal>["moveItem"] = React.useCallback(
    (item, newPosition) => editor.deal.move(item, newPosition),
    [editor],
  )

  const renderItem: ItemRenderFunction<IDeal> = React.useCallback(
    (item, itemRenderProps) => (
      <StyledDeal {...itemRenderProps}>
        <Name isEnabled={item.restrictions.enabled}>{item.name}</Name>
        <MoveHandle {...itemRenderProps} />
      </StyledDeal>
    ),
    [],
  )

  return <DealNavigator {...{ items, selectItem, selectedId, moveItem, renderItem }} />
}

export default Navigator
